module.exports = __webpack_public_path__ + "img/SprainedWrist-02.0726a98c.svg";